import React from 'react';
import { connect } from 'react-redux';

class IsBoss extends React.Component{

	render(){

		const { user } = this.props;

		if( !user.loading && user.data && !user.data.permissions.ezBoss){
			return null;
		}

		return this.props.children;

	}

}

export default connect( 
	state => ({
		user: state.user
	})
 )( IsBoss );


// WEBPACK FOOTER //
// ./src/components/hocs/is-boss.js